'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  routes: [{
    path: '/404',
    name: 'error-404',
    component: require('../views/404.vue')
  }, {
    path: '/403',
    name: 'error-403',
    component: require('../views/403.vue')
  }, {
    name: 'login',
    path: '/login',
    component: require('../views/Login.vue')
  }, {
    name: 'reset-password',
    path: '/reset-password',
    component: require('../views/ResetPassword.vue')
  }, {
    name: 'reset-password-confirm',
    path: '/reset-password-confirm/:uid/:token',
    component: require('../views/ResetPasswordConfirm.vue')
  }, {
    name: 'confirm-email',
    path: '/confirm-email/:key',
    component: require('../views/ConfirmEmail.vue')
  }, {
    path: '/',
    component: require('../views/private/'),
    children: [{
      path: '',
      name: 'panel-home',
      component: require('../views/private/Home.vue')
    }, {
      path: 'campaign-form/:id',
      name: 'campaign-form',
      component: require('../views/private/CampaignForm.vue')
    }, {
      path: 'stats',
      name: 'vendors-stats',
      component: require('../views/private/VendorsHome.vue')
    }, {
      path: 'leads/:id',
      name: 'customer-leads',
      component: require('../views/private/Requests.vue')
    }, {
      path: 'campaigns',
      name: 'campaigns',
      component: require('../views/private/Campaigns.vue')
    }, {
      path: 'campaigns-docs',
      name: 'campaigns-docs',
      component: require('../views/private/CampaignsDocs.vue')
    }, {
      path: 'model-stats',
      name: 'model-stats',
      component: require('../views/private/ModelAnalytics.vue')
    }, {
      path: 'agents-stats',
      name: 'agents-stats',
      component: require('../views/private/AgentAnalytics.vue')
    }, {
      path: 'agents-slots',
      name: 'agents-slots',
      component: require('../views/private/AgentSlots.vue')
    }, {
      path: 'dashboards/:id',
      name: 'user-dashboard-detail',
      component: require('../views/private/Dashboard.vue')
    }, {
      path: 'settings/profile',
      name: 'settings-profile',
      component: require('../views/private/ProfileSettings.vue')
    }, {
      path: 'settings/account',
      name: 'settings-account',
      component: require('../views/private/AccountSettings.vue')
    }, {
      path: 'settings/fields',
      name: 'settings-fields',
      component: require('../views/private/FieldsSettings.vue')
    }, {
      path: 'settings/tags',
      name: 'settings-tags',
      component: require('../views/private/TagsSettings.vue')
    }, {
      path: 'settings/campaigns',
      name: 'settings-campaigns',
      component: require('../views/private/CampaignsSettings.vue')
    }, {
      path: 'settings/filters',
      name: 'routes',
      component: require('../views/private/FiltersSettings.vue')
    }, {
      path: 'settings/models',
      name: 'models',
      component: require('../views/private/ScoringModelRulesSettings.vue')
    }, {
      path: 'epic/clients',
      name: 'epic-clients',
      component: require('../views/private/EpicClients.vue')
    }, {
      path: 'epic/policies',
      name: 'epic-policies',
      component: require('../views/private/Policies.vue')
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.name == null || to.matched.length == 0) {
    return router.push({ name: 'error-404' });
  }

  var vendorRoutes = ['panel-home', 'vendors-stats', 'customer-leads', 'campaigns', 'campaigns-docs'];
  var customerRoutes = ['panel-home', 'campaigns', 'model-stats', 'agents-stats', 'agents-slots', 'zones-stats', 'user-dashboard-detail', 'campaigns', 'campaigns-docs', 'epic-clients', 'epic-policies'];
  var adminRoutes = ['settings-profile', 'settings-account', 'settings-fields', 'settings-tags', 'settings-campaigns', 'routes', 'models'];
  var salesAgentRoutes = ['campaigns', 'campaigns-docs', 'campaing-form'];

  var isVendorRoute = vendorRoutes.includes(to.name);
  var isCustomerRoute = customerRoutes.includes(to.name);
  var isAdminRoute = adminRoutes.includes(to.name);
  var isSalesAgentRoute = salesAgentRoutes.includes(to.name);
  var authRequired = isAdminRoute || isCustomerRoute || isVendorRoute || isSalesAgentRoute;

  _store2.default.dispatch('userReady').then(function () {
    if (authRequired) {
      if (_store2.default.getters.userIsAdmin || _store2.default.getters.accountIsVendor && isVendorRoute || _store2.default.getters.accountIsCustomer && isCustomerRoute || _store2.default.getters.userIsSalesAgent && isSalesAgentRoute) {
        next();
      } else {
        router.push({ name: 'error-404' });
      }
    } else if (to.name == 'login') {
      router.push('/');
    } else {
      next();
    }
  }, function () {
    if (!authRequired) {
      next();
    } else {
      router.push('login');
    }
  });
});

exports.default = router;


//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = 335
// module chunks = 0